import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { SobreDocumentacionEdit } from "./edit";
import { obtenerDescripcionesServiciosAdicionales, setDescripciones } from "../logic";

const EditModal = SobreDocumentacionEdit;
type Entity = models.SobreDocumentacion;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void>;
    idDireccionDestino: number | undefined;
    idSucursalDestino: number | undefined;
    readonly?: boolean;
    error?: kea.FieldError;
    puedeModificarRecoleccion: boolean;
}

export interface BotonesDeps {
    onEdit: (x: Entity) => void;
    onBorrar: (x: Entity) => void;
    onDuplicar: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
function columnas(deps: BotonesDeps): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones([...kea.columnaBotonesDefault(deps),
    {
        onClick: deps.onDuplicar,
        iconClass: fa("copy"),
        tooltip: "Duplicar"
    }]);

    return [
        botones,
        { title: "Cantidad", cell: x => ({ data: x.Cantidad }) },
        { title: "Destino (cli)", cell: x => ({ data: x.NombreCliente }) },
        { title: "Destino (dir)", cell: x => ({ data: x.DescripcionDestino }) },
        { title: "Destino (suc)", cell: x => ({ data: x.NombreSucursal }) },
        { title: "Servicios adicionales", cell: x => ({ data: obtenerDescripcionesServiciosAdicionales(x.ServiciosAdicionales), view: kea.arrayCell() }) },
        { title: "Contenido", cell: x => ({ data: x.NombreContenidoSobre }) },
        { title: "Observaciones", cell: x => ({ data: x.Observaciones }) },
    ];
}

/**
* Listado de SobreDocumentacion
*/
class SobreDocumentacionListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    private handleOnAgregar = async () => {
        var puedeModificarRecoleccion = this.props.puedeModificarRecoleccion;
        //Si no puede modificar checkbox de recolección a domicilio siempre debe de ser true        
        const result = await this.modals.showModal(EditModal, puedeModificarRecoleccion, { IdDireccionDestino: this.props.idDireccionDestino, IdSucursalDestino: this.props.idSucursalDestino, ServiciosAdicionales: { RecoleccionDomicilio: !puedeModificarRecoleccion } } as Entity);;
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        var puedeModificarRecoleccion = this.props.puedeModificarRecoleccion;
        const result = await this.modals.showModal(EditModal, puedeModificarRecoleccion, item);
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?");
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    private handleOnDuplicar = (x: Entity) => {
        this.props.onChange([... this.props.value, { ...x, Observaciones: "" }]);
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar, onDuplicar: this.handleOnDuplicar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <kea.Title titulo="Sobres" size="h4" error={this.props.error} onAgregar={this.props.readonly ? undefined : this.handleOnAgregar} iconClass={fa("envelope-o", "fw")} />
                    </div>
                </div>

                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda={true} />
                {this.modals.component}
            </div>
        );
    }
}
export const SobreDocumentacionList = kea.mapProps(componentToRx(SobreDocumentacionListNoRx), x => ({ ...x, value: x.value || [] }));



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/sobres/list.tsx